import {
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR,
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_ERROR,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR,
  DELETE_IRA_APPLICATION_FUNDING_SUCCESS,
  DELETE_IRA_APPLICATION_FUNDING_ERROR,
} from '../../actions/iraFunding/iraFundingActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  iraFunding: {},
  error: '',
};

export default createReducer(
  {
    [CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR]: iraFundingError,
    [CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR]: iraFundingError,
    [CREATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR]: iraFundingError,
    [CREATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_FUNDING_TYPE_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_FUNDING_TYPE_ERROR]: iraFundingError,
    [CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR]: iraFundingError,
    [CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS]: iraFundingSuccess,
    [CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR]: iraFundingError,
    [UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS]: iraFundingSuccess,
    [UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR]: iraFundingError,
    [DELETE_IRA_APPLICATION_FUNDING_SUCCESS]: iraFundingSuccess,
    [DELETE_IRA_APPLICATION_FUNDING_ERROR]: iraFundingError,
  },
  initialState,
);

function iraFundingSuccess(state, action) {
  return {
    ...state,
    iraFunding: action.payload,
    error: '',
  };
}

function iraFundingError(state, action) {
  return {
    ...state,
    iraFunding: action.payload,
    error: '',
  };
}
